import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { Vehicle } from '../../../shared/model/vehicle';
import { DiagnosisWebSocketService } from '../../service/diagnosis-web-socket.service';
import { Observable } from 'rxjs/Observable';
import { DiagnosisGeneralResult } from '../../../shared/model/diagnosis-general-result';
import { MaterializeAction } from 'angular2-materialize';

@Component({
  selector: 'tx-vehicle-display',
  templateUrl: './vehicle-display.component.html',
  styleUrls: ['./vehicle-display.component.css']
})
export class VehicleDisplayComponent implements OnInit {
  @Input() vehicle: Vehicle;
  @Input() vehicles: Array<Vehicle>;
  @Input() changeVehicle: boolean;
  @Input() enableRestart: boolean;
  @Input() enableRestartAutomatically: boolean;
  running = true;
  loadingText = 'Indisponível';
  restartAutomatically = false;
  modalActions = new EventEmitter<string|MaterializeAction>();
  _run: boolean;

  constructor(private _diagnosisNotification: DiagnosisWebSocketService) {
    this.vehicle = new Vehicle();
    this.setUpDiagnosisFinished();
  }

  ngOnInit() {
  }

  get run() {
    return this._run;
  }

  @Input()
  set run(run) {
    this._run = run;
  }

  restartDiagnosis() {
    this._diagnosisNotification.restart();
    this.running = true;
  }

  restartDiagnosisAutomatically() {
    this.restartAutomatically = !this.restartAutomatically;
    if (!this.running && this.restartAutomatically) {
      this.restartDiagnosis();
    }
  }

  resetDiagnosis(vehicle) {
    this.setDiagnosisVehicle(vehicle);
    this._diagnosisNotification.run(vehicle);
    this.running = true;
    this.modalActions.emit({ action: 'modal', params: ['close'] });
  }

  setDiagnosisVehicle(vehicle) {
    this.vehicle = vehicle;
    this._diagnosisNotification.setVehicle(vehicle);
  }

  closeModal() {
    this.modalActions.emit({ action: 'modal', params: ['close'] });
  }

  setUpDiagnosisFinished() {
    this._diagnosisNotification.response$
      .debounce(() => {
        let time = 0;
        if (this.restartAutomatically) {
          time = 60000;
        }
        return Observable.timer(time);
      })
      .filter(response => response instanceof Array || response instanceof DiagnosisGeneralResult)
      .subscribe(response => {
        if (this.restartAutomatically) {
          this.running = true;
          this.restartDiagnosis();
        } else {
          this.running = false;
        }
      });
  }

  isInRunMode() {
    if (this._run === undefined) {
      return false;
    }
    return this._run;
  }

  restartIsEnabled() {
    if (this.enableRestart === undefined) {
      return true;
    }
    return this.enableRestart;
  }

  restartAutomaticallyIsEnabled() {
    if (this.enableRestartAutomatically === undefined) {
      return true;
    }
    return this.enableRestartAutomatically;
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/diagnosis/component/vehicle-display/vehicle-display.component.ts